<template>
    <el-drawer title="签到记录" :visible.sync="visible" direction="rtl" size="700px" :before-close="handleClose">
        <div style="padding: 0 20px">
            <div style="display: flex; align-items: center; margin-bottom: 16px">
                <span style="font-size: 15px; font-weight: 600; margin-right: 12px">{{ studentName }}</span>
                <span style="font-size: 13px; color: #909399">学号: {{ studentNo }}</span>
            </div>

            <el-form :inline="true" size="small">
                <el-form-item label="日期范围">
                    <el-date-picker v-model="dateRange" type="daterange" range-separator="至"
                        start-placeholder="开始" end-placeholder="结束" value-format="yyyy-MM-dd"
                        style="width: 240px" @change="fetchData"></el-date-picker>
                </el-form-item>
                <el-form-item label="签到类型">
                    <el-select clearable v-model="querySignType" placeholder="全部" style="width: 120px" @change="fetchData">
                        <el-option label="签到" value="SIGN_IN"></el-option>
                        <el-option label="请假" value="LEAVE"></el-option>
                        <el-option label="迟到" value="LATE"></el-option>
                        <el-option label="缺勤" value="ABSENCE"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="fetchData">查询</el-button>
                    <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
                </el-form-item>
            </el-form>

            <el-table :data="list" border stripe v-loading="loading" size="small" max-height="450">
                <el-table-column prop="signDate" label="签到日期" width="110" align="center"/>
                <el-table-column prop="signTime" label="签到时间" width="170" align="center"/>
                <el-table-column prop="signType" label="类型" width="90" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="signTypeTag(scope.row.signType)" size="mini">
                            {{ signTypeLabel(scope.row.signType) }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="是否推送" width="110" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.hasPush === '1'" type="success" size="mini">已推送</el-tag>
                        <el-tag v-else-if="scope.row.hasPush === '2'" type="danger" size="mini">推送失败</el-tag>
                        <el-tag v-else type="info" size="mini">未推送</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="推送时间" width="170" align="center">
                    <template slot-scope="scope">{{ scope.row.pushTime || '-' }}</template>
                </el-table-column>
                <el-table-column prop="remark" label="备注" show-overflow-tooltip/>
                <el-table-column label="操作" width="100" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.hasPush === '2' && isToday(scope.row.signDate)"
                            type="text" size="mini" icon="el-icon-refresh" @click="handleRetry(scope.row)">
                            重推
                        </el-button>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
            </el-table>
            <div style="margin-top: 12px; text-align: right">
                <el-pagination small background layout="total, prev, pager, next"
                    :total="total" :page-size="pageSize" :current-page="pageNum"
                    @current-change="onPageChange">
                </el-pagination>
            </div>
        </div>
    </el-drawer>
</template>

<script>
import signInApi from '@/api/education/sign-in'

export default {
    name: 'SignInLogDrawer',
    data() {
        return {
            visible: false,
            studentId: null,
            studentName: '',
            studentNo: '',
            list: [],
            total: 0,
            pageNum: 1,
            pageSize: 10,
            loading: false,
            dateRange: [],
            querySignType: ''
        }
    },
    methods: {
        open(row) {
            this.studentId = row.id
            this.studentName = row.nickname || row.username
            this.studentNo = row.studentNo || ''
            this.visible = true
            this.pageNum = 1
            this.list = []
            this.dateRange = []
            this.querySignType = ''
            this.fetchData()
        },
        handleClose() {
            this.visible = false
        },
        resetQuery() {
            this.dateRange = []
            this.querySignType = ''
            this.pageNum = 1
            this.fetchData()
        },
        async fetchData() {
            this.loading = true
            try {
                const params = {
                    studentId: this.studentId,
                    pageNum: this.pageNum,
                    pageSize: this.pageSize
                }
                if (this.dateRange && this.dateRange.length === 2) {
                    params.signDateStart = this.dateRange[0]
                    params.signDateEnd = this.dateRange[1]
                }
                if (this.querySignType) {
                    params.signType = this.querySignType
                }
                const res = await signInApi.pageQuery(params)
                const data = res.rows || res.data?.records || []
                this.list = data
                this.total = res.total || res.data?.total || 0
            } catch (e) {
                console.error('加载签到记录失败', e)
            } finally {
                this.loading = false
            }
        },
        async handleRetry(row) {
            if (!this.isToday(row.signDate)) {
                this.$message.warning('仅支持重推当日的签到记录')
                return
            }
            try {
                await this.$confirm('确认重新推送签到消息吗？', '确认重推', { type: 'info' })
                await signInApi.retryPush(row.id)
                this.$message.success('已提交重推请求')
                this.fetchData()
            } catch (e) {
                if (e !== 'cancel') {
                    this.$message.error('重推失败')
                }
            }
        },
        onPageChange(page) {
            this.pageNum = page
            this.fetchData()
        },
        isToday(dateStr) {
            if (!dateStr) return false
            const today = new Date().toISOString().slice(0, 10)
            return dateStr === today
        },
        signTypeLabel(type) {
            const map = { 'SIGN_IN': '签到', 'LEAVE': '请假', 'LATE': '迟到', 'ABSENCE': '缺勤' }
            return map[type] || type
        },
        signTypeTag(type) {
            const map = { 'SIGN_IN': 'success', 'LEAVE': 'warning', 'LATE': 'danger', 'ABSENCE': 'info' }
            return map[type] || 'info'
        }
    }
}
</script>
